import { differenceInCalendarDays } from "date-fns"
import { CFCTimeFrame } from "../../data/_config/shape"

export const newTimestamp = (): number => new Date().getTime()

/**
 * Checks if the end date should be synced with the start date
 *
 * @export
 * @param {Date} start
 * @param {Date} end
 * @returns {boolean}
 */
export function syncEndDate(start: Date, end: Date): boolean {
	return differenceInCalendarDays(start, end) > 0
}

export function calculatedEndDate(start: Date, timeframe: CFCTimeFrame): Date {
	switch (timeframe) {
		case "mesečni":
		default:
			return start
	}
}
